import type { DraggableMetaType, FieldWrapper, ReportField } from "../../../../../../../../api/types/svTypes.ts";
import { ReportType } from "../../../../../../../../api/types/svTypes.ts";
import { isMeasure } from "../../../../utilities/fieldsHelper.ts";
import { isValueField } from "../../common/utilities/dropFieldContainerHelper.ts";

export const SINGLE_VALUE_REPORT_TYPE = ReportType.PieChart;

export const canDropValueItem = (
  item: FieldWrapper<ReportField> | DraggableMetaType,
  reportType: ReportType | undefined,
  values: ReportField[]
) => {
  if (isValueField(item) && isMeasure(item.field) && item.field.meta.capabilities.isScalar) {
    return false;
  }
  switch (reportType) {
    case SINGLE_VALUE_REPORT_TYPE: {
      return values.length === 0;
    }
    case ReportType.BarChart:
    case ReportType.LineChart: {
      return true;
    }
    default:
      return true;
  }
};
